import { render } from "./aboutButtons.vue?vue&type=template&id=21491a12&scoped=true"
import script from "./aboutButtons.vue?vue&type=script&lang=js"
export * from "./aboutButtons.vue?vue&type=script&lang=js"

import "./aboutButtons.vue?vue&type=style&index=0&id=21491a12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21491a12"]])

export default __exports__